import { Model } from "@vuex-orm/core"
import StudentCourse from "@/models/StudentCourse"

export default class Checkin extends Model {
  static get entity() {
    return "checkins"
  }

  static fields() {
    return {
      id: this.attr(null),
      student_course_id: this.attr(null),
      date: this.attr(""),
      type: this.attr(""),
      comment: this.attr(""),
      created_at: this.attr(""),
      updated_at: this.attr(""),
      student_course: this.belongsTo(StudentCourse, "student_course_id"),
    }
  }

  static TYPE_LATE_EXCUSED = "late_excused"
  static TYPE_LATE_UNEXCUSED = "late_unexcused"
  static TYPE_EARLY_DEPARTURE = "early_departure"

  static TYPE_LABELS = {
    late_excused: "retard excusé",
    late_unexcused: "retard non excusé",
    early_departure: "départ avant la fin du cours",
  }

  get statusLabel() {
    return Checkin.TYPE_LABELS[this.type] || this.type
  }

  get evamCode() {
    if (this.type === Checkin.TYPE_LATE_EXCUSED || this.type === Checkin.TYPE_LATE_UNEXCUSED) {
      return " (R)"
    }
    return ""
  }

  static types(withAll = false) {
    const types = [
      { value: Checkin.TYPE_LATE_EXCUSED, text: Checkin.TYPE_LABELS[Checkin.TYPE_LATE_EXCUSED] },
      { value: Checkin.TYPE_LATE_UNEXCUSED, text: Checkin.TYPE_LABELS[Checkin.TYPE_LATE_UNEXCUSED] },
      { value: Checkin.TYPE_EARLY_DEPARTURE, text: Checkin.TYPE_LABELS[Checkin.TYPE_EARLY_DEPARTURE] },
    ]
    if (withAll) {
      types.unshift({ value: "tout", text: "tout" })
    }
    return types
  }

  static async getCheckinsBetweenDates(start, end, type, activeCoursesOnly = false) {
    return await this.api().get(
      `/checkins/between_dates?start=${start}&end=${end}&type=${type}&active_courses=${activeCoursesOnly}`,
      {
        dataKey: "data",
      }
    )
  }

  static async getByStudentCourseId(student_course_id) {
    return await this.api().get(`/checkins/student_course/${student_course_id}`, {
      dataKey: "data",
    })
  }

  static async post(checkin) {
    return this.api().post(`/checkins`, checkin, {
      dataKey: "data",
    })
  }

  static async put(checkin) {
    return this.api().put(`/checkins/${checkin.id}`, checkin, {
      dataKey: "data",
    })
  }

  static async deleteOne(id) {
    return await this.api().delete("/checkins/" + id, {
      delete: id,
    })
  }

  static async deleteByDateAndStudentCourse(student_course_id, date) {
    return await this.api().delete(`/checkins/by-date?student_course_id=${student_course_id}&date=${date}`)
  }
}
